import { getLastUsedClinic } from 'utils/clinicPersistence';
import getSortedClinicList from 'utils/clinicList';

// The clinic the app should land in when the URL names none: the last clinic
// used in this org if it is still granted, otherwise the first alphabetically.
// Returns undefined when the account has no clinic grants at all.
export default function getDefaultClinicId(orgId, clinicGrants) {
    const lastUsedClinic = getLastUsedClinic(orgId);
    if (lastUsedClinic && clinicGrants?.[lastUsedClinic]) {
        return lastUsedClinic;
    }
    return getSortedClinicList(clinicGrants)[0]?.id;
}
